const selectDog = (e) => {
    const option = $(`#${e.target.value}`)
    let weight = option.attr('data-dog-weight')
    let age = option.attr('data-dog-birth')

    if (weight) {
        weight = parseInt(weight)
    }

    if (age) {
        age = new Date(age).getFullYear()
        age = new Date().getFullYear() - age
    }

    const variants = $('.productSection__variantOption').map(function (idx, ele) {
        return {
            value: $(ele).val(),
            maxWeight: parseInt($(ele).attr('data-max-weight')),
            minWeight: parseInt($(ele).attr('data-min-weight')),
            maxAge: parseInt($(ele).attr('data-max-age')),
            minAge: parseInt($(ele).attr('data-min-age')),
        };
    }).get();

    variants.shift()

    const weightFilter = variants.filter(({ maxWeight,
        minWeight }) => {
        maxWeight = maxWeight || 200
        minWeight = minWeight || 0

        if (weight <= maxWeight && weight >= minWeight) {
            return true
        }

        return false

    })

    const selectedVariant = weightFilter.find(({
        maxAge,
        minAge }) => {

        maxAge = maxAge || 200
        minAge = minAge || 0
        if (age <= maxAge && age >= minAge) {
            return true
        }

        return false
    })

    let selected = weightFilter[0]?.value || "0"

    if (selectedVariant) {
        selected = selectedVariant.value
    }

    $('.productSection__form .productSection__variantSelect').each(function () {
        $(this).val(selected)
        $('.productSection__form').trigger('change')
    })

}


const dogSelector = $('#product_select-dog-wrapper')
dogSelector.on('change', selectDog)

const fetchDogs = async () => {
// debugger;
    $('#product_select-dog-wrapper svg').removeClass('hidden')
    const customerEmail = $('#product-details-section').attr('data-customer-email') 
    if (customerEmail) {
        // Signed with the same token as the profile screen (snippets/profile.liquid, in the account slideout).
        const profile = $('#profile-overview')
        const query = new URLSearchParams({ q: profile.attr('data-customer-id') || '', t: profile.attr('data-t') || '', sig: profile.attr('data-sig') || '' })
        const result = await fetch(`https://bussa.co.il/dogs?${query}`, { headers: { 'Accept': 'application/json' } });
        result.json().then((response) => {
        
            if (response.status === 200) {
                if (response.data.length > 0) {
                    response.data.map((dog) => {
                        // Dog data is user input: set it as text/attributes, never as HTML.
                        $('#productSection__dogSelect').append(
                            $('<option class="productSection__dogOption p">')
                                .attr({ id: dog._id, 'data-dog-weight': dog.weight, 'data-dog-birth': dog.birthday })
                                .val(dog._id)
                                // As before: each new option becomes selected, so the last dog ends up selected (matches the last selectDog call).
                                .prop('selected', true)
                                .text(dog.name ?? '')
                        );

                        selectDog({ target: { value: dog._id } })
                    });

                    $('#product_select-dog-wrapper .product_variant--background').removeClass('hidden')
                    $('#product_select-dog-wrapper svg').addClass('hidden')

                } else {
                    $('#product_select-dog-wrapper .product_variant--background').addClass('hidden')
                    $('#product_select-dog-wrapper svg').addClass('hidden')
                }
            }
        })
    }
}

fetchDogs()